export default {
  form: {
    firstName: 'Förnamn',
    firstNamePlaceholder: 'Ange förnamn',
    lastName: 'Efternamn',
    lastNamePlaceholder: 'Ange efternamn',
    email: 'E-postadress',
    emailPlaceholder: 'Ange e-postadress',
    personalNumber: 'Personnummer',
    birthYear: 'Födelseår',
    biologicalGender: 'Biologiskt kön',
    geneticGender: 'Genetiskt kön',
    department: 'Avdelning',
    departmentPlaceholder: 'Ange avdelning, t.ex. HR, IT, Försäljning',
    market: 'Marknad',
    continue: 'Fortsätt',
    add: 'Lägg till',
    save: 'Spara',
    saveChanges: 'Spara ändringar',
    changesSaved: 'Ändringarna sparades',
    saveError: 'Något gick fel när ändringarna skulle sparas!',
    cancel: 'Avbryt',
    yes: 'Ja',
    no: 'Nej',
    chooseOption: 'Välj ett alternativ',
    choose: 'Välj...',
    language: 'Språk',
    next: 'Nästa',
    close: 'Stäng',
    loading: 'Skickar...',
    skip: 'Hoppa över',
  },
  market: {
    sweden: 'Sverige',
    norway: 'Norge',
  },
  validation: {
    firstNameRequired: 'Förnamn krävs',
    lastNameRequired: 'Efternamn krävs',
    emailRequired: 'E-postadress krävs',
    invalidEmail: 'Ogiltig e-postadress',
    invalidLanguage: 'Vänligen välj ett giltigt språk.',
    invalidMarket: 'Vänligen välj en giltig marknad.',
    departmentTooLong: 'Avdelning får inte överstiga 100 tecken',
  },
  gender: {
    female: 'Kvinna',
    male: 'Man',
    preferNotToSay: 'Föredrar att inte uppge',
  },
  errors: {
    somethingWentWrong: 'Någonting gick fel! Vänligen försök igen eller kontakta support på support@estercare.com',
    tryAgainOrContact: 'Något gick fel när vi försökte lägga till medarbetaren. Försök igen.',
    networkBlocked:
      'Den här funktionen stöds inte på ditt nätverk. Vänligen försök från ett annat nätverk eller kontakta support på support@estercare.com.',
    ssoOrgNotConfigured: 'Din arbetsgivare har inte aktiverat EsterCare ännu.',
    ssoLoginFailed:
      'Det gick inte att logga in via din förmånsportal. Försök igen eller kontakta support på support@estercare.com',
    ssoUseSsoLogin: 'Det här kontot loggar in via din arbetsgivare. Öppna EsterCare via din förmånsportal.',
    ssoUsePasswordLogin: 'Det här kontot loggar in med e-post och lösenord. Logga in på portalen på vanligt sätt.',
    ssoAccountConflict:
      'Det här kontot kan inte användas för att logga in via din förmånsportal. Kontakta support på support@estercare.com',
  },
  navigation: {
    home: 'Hem',
    overview: 'Översikt',
    services: 'Tjänster',
    healthCalls: 'Hälsosamtal',
    screening: 'Screening',
    messages: 'Chatt',
    statistics: 'Statistik',
    employees: 'Medarbetare',
    billing: 'Fakturering',
    support: 'Support',
    training: 'Utbildning',
    knowledgeBank: 'Kunskapsbank',
    yourHealth: 'Din hälsoplan',
    myAccount: 'Mitt konto',
    logout: 'Logga ut',
  },
  file: {
    needsTwoRows: 'Filen behöver innehålla minst två rader med data.',
    needsThreeColumns: 'Filen behöver innehålla minst tre kolumner: Email, förnamn och efternamn.',
    missingValues: 'En eller flera rader saknar värden i en eller flera kolumner.',
    invalidEmails: 'Ogiltig e-postadress på en eller flera rader.',
    fileValid: 'Filen är giltig.',
    managerColumnFormat: 'Columnen för chefsposition måste anges som ett "true" eller "false" värde.',
    languageColumnFormat: 'Språkkolumnen måste anges som "sv" för svenska, "en" för engelska eller "nb" för norska.',
    invalidLanguage: 'Vänligen välj ett giltigt språk.',
    dragFileHere: 'Dra filen hit eller klicka i rutan för att importera.',
    dropFileHere: 'Släpp filen här...',
    fileTypeNotSupported: 'Den här filtypen stöds inte.',
    uploadingFile: 'Laddar upp filen...',
    uploadFailed: 'Det gick inte att ladda upp filen, vänligen försök igen.',
    uploadComplete: 'Uppladdning klar!',
  },
  table: {
    name: 'Namn',
    added: 'Tillagd',
    lastLogin: 'Senast inloggad',
  },
  menu: {
    removeUser: 'Ta bort användare',
    removeAdminRights: 'Ta bort adminbehörighet',
    giveAdminRights: 'Ge adminbehörighet',
    removeManagerRights: 'Ta bort medarbetaransvar',
    addManagerRights: 'Lägg till medarbetaransvar',
    clearScreening: 'Rensa min screening',
    esterInvite: 'Inbjuden av ',
  },
  alerts: {
    screeningCleared: 'Din screening har rensats',
  },
  welcome: {
    greeting: 'Hej {{firstName}}!',
    title: 'Välkommen till EsterCares hälsoportal',
    subtitle: 'För att komma igång behöver vi veta lite mer om dig.',
    zipCode: 'Ditt postnummer',
    errorZipCode: 'Felaktigt format på postnummer',
    errorBirthYear: 'Felaktigt format på födelseår',
    isManager: 'Jag har medarbetaransvar',
  },
  notFound: {
    title: 'Sidan du söker finns <br /> tyvärr inte',
    imageAlt: 'Tre kvinnor som samtalar (illustration)',
    backToHome: 'Gå tillbaka till vår startsida',
  },
  loggedOut: {
    message: 'Du är utloggad. Öppna EsterCare via din förmånsportal igen.',
  },
  addEmployee: {
    title: 'Lägg till medarbetare',
    addMultipleTitle: 'Lägg till flera medarbetare',
    addMultipleDescription: 'Lägg till flera medarbetare samtidigt genom att lista dem i en CSV-fil.',
    templateInstruction: 'Använd vår mall för att formatera filen på ett korrekt sätt.',
    assignManagerRights: 'Tilldela chefsbehörighet?',
    wantToAddMany: 'Vill du lägga till många medarbetare?',
    wantToAddOne: 'Vill du bara lägga till en medarbetare?',
  },
  content: {
    morePodcasts: 'Fler poddavsnitt',
    moreArticles: 'Fler artiklar',
    showMore: 'Visa fler',
    toKnowledgeBank: 'Till vår kunskapsbank',
    article: 'Artikel',
    podcast: 'Podd',
    episode: 'Avsnitt',
    webinar: 'Föreläsning',
    missingDescription: 'Saknar beskrivning',
    writtenBy: 'Artikeln är skriven av:',
    onlyAvailableInSwedish: 'Endast tillgängligt på svenska',
  },
  faq: {
    title: 'Vanliga frågor',
    noAnswerText: 'Hittar du inte svaret på det du letar efter?',
    visitSupport: 'Besök supporten',
  },
  training: {
    confirmCancel: 'Är du säker på att du vill avbryta?',
    progressNotSaved: 'Om du lämnar utbildningen nu kommer dina framsteg inte att sparas.',
    continueTraining: 'Nej, fortsätt utbildningen',
    cancelAndLeave: 'Ja, avbryt och lämna',
    duration: 'Längd',
    minutes: 'min',
    completed: 'Avklarad',
    listenSpotify: 'Lyssna via Spotify',
  },
  roles: {
    admin: 'Admin',
    employee: 'Anställd',
    adminTag: 'ADMIN',
    managerTag: 'PERSONALANSVAR',
    invitedTag: 'INBJUDEN',
  },
  service: {
    active: 'Aktiv',
    readMore: 'Läs mer',
  },
  statistics: {
    trainingNotStarted: 'Utbildning ej påbörjad',
    trainingInProgress: 'Utbildning pågående',
    trainingCompleted: 'Utbildning genomförd',
  },
  language: {
    swedish: 'Svenska',
    english: 'Engelska',
    norwegian: 'Norska',
  },
  other: {
    yourOrganisation: 'din organisation',
  },
  dataPolicy: {
    title: 'Så hanterar vi dina uppgifter',
    titleUpdated: 'Vi har uppdaterat vår dataskyddspolicy',
    ingress: 'Här är hela vår dataskyddspolicy för hälsoportalen. Du hittar den alltid igen under din profil.',
    summary:
      'I vår dataskyddspolicy beskriver vi hur EsterCare hanterar dina personuppgifter i hälsoportalen. Kort sagt: din organisation ser aldrig dina svar, din hälsoplan eller dina meddelanden.',
    summaryUpdated: 'Vi har gjort ändringar i hur vi beskriver hanteringen av dina personuppgifter i hälsoportalen.',
    readPolicy: 'Läs dataskyddspolicyn',
    compactHint: 'Du hittar alltid policyn igen under din profil.',
    readMore: 'Läs mer',
    ingressUpdated:
      'Vi har gjort ändringar i hur vi beskriver vår hantering av dina personuppgifter. Läs igenom den nya versionen och bekräfta för att fortsätta.',
    whatsNew: 'Det här är nytt i version {{version}}',
    versionLine: 'Version {{version}} · Gäller från {{date}}',
    openInNewWindow: 'Öppna i nytt fönster',
    loggedInAs: 'Inloggad som',
    hint: 'Det här är en bekräftelse på att du tagit del av informationen. Samtycke till hälsouppgifter frågar vi om separat innan screeningen.',
    acknowledge: 'Jag har tagit del av informationen',
    decline: 'Avböj',
    declineTitle: 'Vill du avböja?',
    declineBody:
      'Du behöver bekräfta att du tagit del av dataskyddspolicyn för att använda hälsoportalen. Om du avböjer loggas du ut. Ditt konto finns kvar och du kan komma tillbaka när som helst.',
    declineConfirm: 'Avböj och logga ut',
    declineBack: 'Tillbaka till policyn',
    declinedTitle: 'Du är nu utloggad',
    declinedBody:
      'Du behöver bekräfta att du tagit del av vår dataskyddspolicy för att använda EsterCares hälsoportal. Du är nu utloggad och kan komma tillbaka när som helst. Vill du att ditt konto tas bort, kontakta din organisation eller support@estercare.com.',
    loginAgain: 'Logga in igen',
    menuLink: 'Dataskyddspolicy',
    loadError: 'Det gick inte att läsa in policyn. Försök igen om en stund.',
    submitError: 'Något gick fel. Försök igen.',
    retry: 'Försök igen',
  },
} as const
